import React from 'react'
import {
  CCard,
  CCardBody,
  CCardText,
  CCol,
  CImage,
  CModal,
  CModalBody,
  CModalHeader,
  CRow
} from '@coreui/react'
import { BsBackspace } from 'react-icons/bs'
import './styles.css'

const ModalOpenImageModal = ({ handleClose, visible, picture = '' }) => {
  return (
    <CModal
      size="lg"
      visible={visible}
      onClose={handleClose}
      alignment="center"
    >
      <CModalHeader className="border-0" closeButton />
      <CModalBody style={{ marginBottom: 50 }}>
        <CImage
          align="center"
          src={picture}
          style={{ maxWidth: '100%', maxHeight: '100%' }}
        />
      </CModalBody>
    </CModal>
  )
}

export default ModalOpenImageModal
